export const CONSULTA_TIPOS_ORDEM = ["ipva", "multas", "licenciamento"];

export const CONSULTA_TIPOS_ROTULOS = {
  ipva: "IPVA",
  multas: "Multas",
  licenciamento: "Licenciamento",
};

const criarMapaBase = (valorInicial = false) =>
  CONSULTA_TIPOS_ORDEM.reduce((acc, tipo) => {
    acc[tipo] = valorInicial;
    return acc;
  }, {});

export const criarConsultaTiposPadrao = () => criarMapaBase(true);

const normalizarValorBooleano = (valor) => {
  if (typeof valor === "boolean") {
    return valor;
  }
  if (typeof valor === "number") {
    return valor !== 0;
  }
  if (typeof valor === "string") {
    const texto = valor.trim().toLowerCase();
    return ["1", "true", "sim", "on"].includes(texto);
  }
  return Boolean(valor);
};

export const normalizarConsultaTipos = (entrada) => {
  if (!entrada) {
    return criarConsultaTiposPadrao();
  }

  const resultado = criarMapaBase(false);
  const habilitar = (tipo) => {
    const normalizado = String(tipo || "")
      .trim()
      .toLowerCase();
    if (CONSULTA_TIPOS_ORDEM.includes(normalizado)) {
      resultado[normalizado] = true;
    }
  };

  if (Array.isArray(entrada)) {
    entrada.forEach((valor) => habilitar(valor));
  } else if (typeof entrada === "string") {
    entrada
      .split(/[;,\s]+/)
      .map((parte) => parte.trim())
      .filter(Boolean)
      .forEach((parte) => habilitar(parte));
  } else if (typeof entrada === "object") {
    Object.entries(entrada).forEach(([chave, valor]) => {
      if (normalizarValorBooleano(valor)) {
        habilitar(chave);
      }
    });
  }

  const algumSelecionado = CONSULTA_TIPOS_ORDEM.some((tipo) => resultado[tipo]);
  return algumSelecionado ? resultado : criarConsultaTiposPadrao();
};

export const consultaTiposToArray = (entrada) => {
  const mapa = normalizarConsultaTipos(entrada);
  return CONSULTA_TIPOS_ORDEM.filter((tipo) => mapa[tipo]);
};

export const consultaTiposSelecionadosList = (entrada) => {
  const mapa = normalizarConsultaTipos(entrada);
  return CONSULTA_TIPOS_ORDEM.filter((tipo) => mapa[tipo]);
};

export const consultaTiposRotulos = (entrada) =>
  consultaTiposSelecionadosList(entrada).map((tipo) => CONSULTA_TIPOS_ROTULOS[tipo]);

export const formatarConsultaTiposResumo = (entrada) => {
  const rotulos = consultaTiposRotulos(entrada);
  if (rotulos.length === CONSULTA_TIPOS_ORDEM.length) {
    return "IPVA, Multas e Licenciamento";
  }
  if (rotulos.length === 0) {
    return "IPVA, Multas e Licenciamento";
  }
  if (rotulos.length === 1) {
    return rotulos[0];
  }
  if (rotulos.length === 2) {
    return rotulos.join(" e ");
  }
  return `${rotulos.slice(0, -1).join(", ")} e ${rotulos.slice(-1)}`;
};
